import { Controller } from "@hotwired/stimulus"
import { clearButtonBusy, isButtonBusy, markButtonBusy } from "../lib/button_loading"

// The BUTTON-8 busy state for a form Turbo does NOT handle (`turbo: false`):
// the sign-in, sign-up, password and verification pages submit natively, so
// the global Turbo submit hook (lib/turbo_submit_busy.js) never sees them.
//
// On submit the button keeps its label, shows the shared `.gl-btn-spinner` in
// its icon's place and carries aria-busy="true" until the page goes away; a
// second submit while busy is prevented. The button is never disabled, so the
// browser still sends the submitter's name/value and nothing about how the
// form submits changes.
//
// Busy is applied one task after the submit event, and only when no other
// listener cancelled the submit (a client-side check that keeps the user on
// the page must not leave a spinning button behind). A page restored from the
// back/forward cache drops the busy state, so the button works again.
//
//   = form_with ..., data: { turbo: false, controller: 'native-submit-busy',
//                            action: 'submit->native-submit-busy#mark' }
const SUBMIT_SELECTOR = 'button[type="submit"], button:not([type]), input[type="submit"]'

export default class extends Controller {
  connect() {
    this.onPageShow = (event) => {
      if (event.persisted) this.reset()
    }
    window.addEventListener("pageshow", this.onPageShow)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.onPageShow)
  }

  mark(event) {
    const button = event.submitter || this.element.querySelector(SUBMIT_SELECTOR)
    if (this.pending || isButtonBusy(button)) {
      event.preventDefault()
      return
    }
    this.pending = true
    setTimeout(() => {
      if (event.defaultPrevented || !button) {
        this.pending = false
        return
      }
      markButtonBusy(button)
      this.busyButton = button
    }, 0)
  }

  reset() {
    this.pending = false
    if (!this.busyButton) return
    clearButtonBusy(this.busyButton)
    this.busyButton = null
  }
}
